// extracted by mini-css-extract-plugin
module.exports = {"container":"nj-z","links":"oj-z"};